module.exports = __webpack_public_path__ + "img/circle1.7021592c.svg";